import React, { useState } from "react";
import { Login } from "@mui/icons-material";
import { focusItems } from "../../../../data/workspaceData";
import { dashboardTabCopy } from "../../../../data/workspaceConfig";
import { DashboardTabs } from "../../common/WorkspaceChrome";
import { AnalyticsTab } from "./subtabs/AnalyticsTab";
import { ApprovalsTab } from "./subtabs/ApprovalsTab";
import { MyActivityTab } from "./subtabs/MyActivityTab";
import { OverviewTab } from "./subtabs/OverviewTab";
import { TeamActivityTab } from "./subtabs/TeamActivityTab";

const activityRows = [
  { label: "Tasks due today", value: "9", detail: "4 high priority" },
  { label: "Meetings", value: "3", detail: "Standup, client review, interview" },
  { label: "Attendance", value: "6h 25m", detail: "Tracker online" },
  { label: "Leaves", value: "1", detail: "WFH request pending" },
];

const teamRows = [
  { name: "Delivery Team", status: "12 online", detail: "3 blocked, 2 in review" },
  { name: "Sales Team", status: "6 active", detail: "8 demos scheduled this week" },
  { name: "Training Team", status: "4 sessions", detail: "2 certificates pending approval" },
  { name: "People Ops", status: "5 requests", detail: "Leave and attendance corrections" },
];

const initialApprovalRows = [
  { title: "Leave approval", owner: "Riya Kapoor", meta: "Sick leave · Today", status: "Pending" },
  { title: "Attendance correction", owner: "Kabir Shah", meta: "Missing checkout", status: "Review" },
  { title: "Client milestone", owner: "Acme Digital", meta: "File upload approval", status: "Waiting" },
  { title: "Wallet payout", owner: "Maya Singh", meta: "Commission payout", status: "Finance" },
];

const analyticsRows = [
  { label: "Delivery health", value: "82%", note: "3 risky projects" },
  { label: "Team utilization", value: "72%", note: "2 overloaded members" },
  { label: "Lead conversion", value: "24%", note: "+6% from last month" },
  { label: "Attendance quality", value: "91%", note: "6 late check-ins" },
];

export function DashboardView({ activeTab = "Overview", setActiveTab = () => {} }) {
  const tabInfo = dashboardTabCopy[activeTab] || dashboardTabCopy.Overview;
  const [focusQueue, setFocusQueue] = useState(() =>
    focusItems.map((item) => ({ ...item, state: "Open" }))
  );
  const [approvalQueue, setApprovalQueue] = useState(initialApprovalRows);
  const [dashboardNotice, setDashboardNotice] = useState("");

  const createDashboardAction = () => {
    const action = {
      title: "New dashboard action",
      meta: "Created from dashboard quick action",
      status: "Work",
      state: "Open",
    };
    setFocusQueue((items) => [action, ...items]);
    setDashboardNotice("New dashboard action added to Today's command center.");
  };

  const completeFocusItem = (title) => {
    setFocusQueue((items) =>
      items.map((item) => (item.title === title ? { ...item, state: "Completed" } : item))
    );
    setDashboardNotice("Focus item marked completed.");
  };

  const openFocusItem = (item) => {
    const targetTab = item.status === "People" ? "Team Activity" : item.status === "Reports" ? "Analytics" : "Approvals";
    setActiveTab(targetTab);
    setDashboardNotice(`${item.title} opened in ${targetTab}.`);
  };

  const decideApproval = (title, decision) => {
    setApprovalQueue((items) =>
      items.map((item) => (item.title === title ? { ...item, status: decision } : item))
    );
    setDashboardNotice(`${title} ${decision.toLowerCase()}.`);
  };

  const renderSubtab = () => {
    if (activeTab === "My Activity") return <MyActivityTab activityRows={activityRows} />;
    if (activeTab === "Team Activity") return <TeamActivityTab teamRows={teamRows} />;
    if (activeTab === "Approvals") return <ApprovalsTab approvalQueue={approvalQueue} decideApproval={decideApproval} />;
    if (activeTab === "Analytics") return <AnalyticsTab analyticsRows={analyticsRows} />;

    return (
      <OverviewTab
        completeFocusItem={completeFocusItem}
        focusQueue={focusQueue}
        openFocusItem={openFocusItem}
      />
    );
  };

  return (
    <>
      <DashboardTabs activeTab={activeTab} setActiveTab={setActiveTab} />

      {dashboardNotice ? (
        <div className="dashboard-notice" role="status">
          <span>{dashboardNotice}</span>
          <button onClick={() => setDashboardNotice("")} type="button">Clear</button>
        </div>
      ) : null}

      <section className="hero-panel module-hero">
        <div className="hero-copy">
          <span className="pill">Dashboard · {activeTab}</span>
          <div className="hero-title-row"><h2>{tabInfo.title}</h2></div>
          <p className="hero-context-text">{tabInfo.text}</p>
          <div className="hero-actions">
            <button className="primary-action" onClick={createDashboardAction} type="button">Create action</button>
            <button className="secondary-action" onClick={() => setDashboardNotice("Workspace session opened from dashboard.")} type="button">
              <Login fontSize="small" />
              Open workspace session
            </button>
          </div>
        </div>
        <div className="relationship-preview compact-preview" aria-label="Workspace summary">
          <div className="node founder">Company</div>
          <div className="node-row">
            <div className="node">Work</div>
            <div className="node">People</div>
          </div>
          <div className="node-row">
            <div className="node">Clients</div>
            <div className="node">Reports</div>
          </div>
        </div>
      </section>

      {renderSubtab()}
    </>
  );
}
